
export const handlePointerDown = (event, elementId) => {
    let shiftX;
    let shiftY;
    document.body.className = 'dragging';
    let element = document.getElementById(elementId);
    event.preventDefault(); // prevent selection start (browser action)
    event.stopPropagation();

    shiftX = event.clientX - element.getBoundingClientRect().left;
    shiftY = event.clientY - element.getBoundingClientRect().top;

    element.setPointerCapture(event.pointerId);

    element.onpointermove = event => {
        let newLeft = event.clientX - shiftX - element.parentNode.getBoundingClientRect().left;

        if (newLeft < 0) {
            newLeft = 0;
        }
        let rightEdge = element.parentNode.offsetWidth - element.offsetWidth;
        if (newLeft > rightEdge) {
            newLeft = rightEdge;
        }
        
        let newTop = event.clientY - shiftY - element.parentNode.getBoundingClientRect().top;
        
        if(newTop < -10) {
            newTop = -10;
        }
        let bottomEdge = element.parentNode.offsetHeight - 70;
        
        if(newTop > bottomEdge) {
            newTop = bottomEdge;
        }

        element.style.left = newLeft + 'px';
        element.style.top = newTop + 'px';
        element.style.bottom = 'auto';
        element.style.transform = 'none';
    };
    element.ondragstart = () => false;
    element.onpointerup = event => {
        element.onpointermove = null;
        document.body.className = '';
    };
};




